import { Component } from "preact";
// eslint-disable-next-line no-unused-vars
import PropTypes from "prop-types";
import { combineClasses, E_Modification } from "@green24/npm-javascript-utils";
import Options from "./OptionsInput";

class ToggleInput extends Component {
	render({className}) {
		return (
			<Options
				options={[
					{text: "on", value: true},
					{text: "off", value: false},
				]}
				{...this.props}
				className={combineClasses("toggle-input", className)}
			/>
		);
	}

	static get propTypes() {
		return {
			value: PropTypes.bool,
			path: PropTypes.string,
			onModify: PropTypes.func,
			label: PropTypes.any,
		}
	}

	static get defaultProps() {
		return {
			onModify: (value, path, type = E_Modification.ITEM_SET) => null,
			value: false,
		}
	}
}

export default ToggleInput;
